module.exports = __webpack_public_path__ + "static/img/sahua0.059f64ff.png";